<template>
  <a-config-provider
    :locale="locale"
    :theme="{
      token: {
        colorPrimary: '#1B7FBD',
      },
    }"
  >
    <div class="main-content" ref="mainContent">
      <router-view />

      <a-modal
        v-model:open="visibleLogin"
        centered
        :footer="null"
        @cancel="cancel"
        :getContainer="() => $refs.mainContent"
        :maskClosable="false"
        :keyboard="false"
      >
        <div class="modal-login">
          <div class="title mb-35 font-500">登 录</div>
          <a-form
            :model="formState"
            name="basic"
            :hideRequiredMark="true"
            autocomplete="off"
            @finish="onSubmit"
            ref="loginFormRef"
          >
            <a-form-item
              name="tel"
              :maxlength="11"
              :rules="[
                {
                  required: true,
                  validator: handleCheckPhone,
                  trigger: 'blur',
                },
              ]"
            >
              <a-input
                class="phone-input"
                v-model:value="formState.tel"
                placeholder="请输入手机号"
                :maxlength="11"
              />
            </a-form-item>
            <a-form-item
              name="captchaCode"
              :rules="[
                {
                  required: true,
                  trigger: 'blur',
                  message: '请输入图形验证码',
                },
              ]"
            >
              <div class="captcha-box">
                <img :src="captcha.img" alt="" />
                <a-button
                  @click="refreshCaptcha"
                  size="middle"
                  type="link"
                  :disabled="seconds < 120"
                  >刷新</a-button
                >
              </div>
              <a-input
                v-model:value="formState.captchaCode"
                placeholder="请输入图形验证码"
                :maxLength="4"
              />
            </a-form-item>
            <a-form-item
              name="code"
              :maxlength="6"
              :rules="[
                {
                  required: true,
                  validator: handleCheck6Code,
                  trigger: 'blur',
                },
              ]"
            >
              <div style="display: flex; align-items: center">
                <a-input
                  v-model:value="formState.code"
                  placeholder="请输入验证码"
                  class="code-input"
                  :maxlength="6"
                />
                <a-button
                  @click="handleSendCode"
                  size="middle"
                  style="padding: 0; border: 0"
                  type="link"
                  class="sendcode"
                  :disabled="seconds < 120"
                  >{{ btnText }}</a-button
                >
              </div>
            </a-form-item>
            <a-button
              class="sure-btn"
              html-type="submit"
              type="primary"
              block
              :disabled="codeSubmitFlag"
              >登录</a-button
            >
            <div class="tip mt-36">未注册用户验证后将自动注册</div>
          </a-form>
        </div>
      </a-modal>
    </div>
  </a-config-provider>
</template>

<script setup>
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import locale from "ant-design-vue/es/locale/zh_CN";
import { ref, reactive, computed, onMounted, watch } from "vue";
import { checkPhone, check6Code } from "@/utils/validate";
import { sendCode, login2, getCaptchaAuth } from "@/api/platform";
import { notification, message } from "ant-design-vue";
import { useStore } from "vuex";

import { toNewPlay } from "@/utils/help";

dayjs.locale("zh-cn");

const store = useStore();

const mainContent = ref();
const loginFormRef = ref(null);

const formState = reactive({
  tel: "",
  code: "",
  captchaCode: "",
});

const visibleLogin = computed(() => {
  // return store.getters["app/getShowLoginModel"];
  return store.state.app.showLoginModel;
});
watch(visibleLogin, (newVal) => {
  if (newVal) {
    refreshCaptcha();
  }
});
let btnText = ref("发送验证码");
let seconds = ref(120);

let inter = null;
const _timer = () => {
  inter = setInterval(() => {
    seconds.value--;
    btnText.value = `${seconds.value}s后重新发送`;
    if (seconds.value <= 0) {
      clearInterval(inter);
      btnText.value = "发送验证码";
      seconds.value = 120;
    }
  }, 1000);
};

const platformId = process.env.VUE_APP_PLATFORM_ID;
const captcha = ref({
  captchaKey: "",
  img: "",
});
const refreshCaptcha = async () => {
  try {
    const { results } = await getCaptchaAuth();
    captcha.value = { ...results };
  } catch (error) {
    console.error(error);
    message.error("获取图形验证码失败");
  }
};
const handleSendCode = async () => {
  const valid = await loginFormRef.value
    .validateFields(["tel", "captchaCode"])
    .catch(() => {});
  if (!valid) {
    return;
  }
  if (seconds.value < 120) {
    return;
  }
  loginFormRef.value
    .validateFields("tel")
    .then(async () => {
      try {
        const params = {
          phone: formState.tel,
          type: "pcStudentLogin",
          smsSource: "YM",
          captchaKey: captcha.value.captchaKey,
          captchaCode: formState.captchaCode,
        };
        await sendCode(params);
        notification.success({
          message: "成功",
          description: "验证码发送成功",
        });
        // 定时器
        _timer();
      } catch (error) {
        console.error(error);
        notification.error({
          message: "失败",
          description: "验证码发送失败",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const codeSubmitFlag = ref(false);

const onSubmit = async (formData) => {
  codeSubmitFlag.value = true;
  const params = {
    phone: formData.tel,
    code: formData.code,
    source: `PLATFORM_ID_${platformId}`,
  };
  try {
    const { results } = await login2(params);
    visibleLogin.value = false;
    codeSubmitFlag.value = false;
    if (results.token) {
      localStorage.setItem("token", results.token.split(" ")[1]);
      // 获取用户信息
      store.dispatch("user/getUserInfoAction");
    }
    notification.success({
      message: "成功",
      description: "登录成功",
    });
    store.commit("app/setShowLoginModel", false);
    // 清空输入框
    formState.tel = "";
    formState.code = "";
    formState.captchaCode = "";
    // 有课程id直接去播放页
    let courseId = sessionStorage.getItem("courseId");
    if (courseId) {
      sessionStorage.removeItem("courseId");
      toNewPlay(courseId);
    }
  } catch (error) {
    codeSubmitFlag.value = false;
  }
};

const cancel = () => {
  store.commit("app/setShowLoginModel", false);
};

const handleCheckPhone = (_rule, value) => {
  if (checkPhone(value)) {
    return Promise.resolve();
  } else if (!value) {
    return Promise.reject("请输入手机号");
  } else {
    return Promise.reject("请输入正确的手机号");
  }
};
const handleCheck6Code = () => {
  if (check6Code(formState.code)) {
    return Promise.resolve();
  } else if (!formState.code) {
    return Promise.reject("请输入验证码");
  } else {
    return Promise.reject("请输入正确的验证码");
  }
};

onMounted(() => {
  refreshCaptcha();
});
</script>

<style lang="less" scoped>
.main-content {
  height: 100%;
  :deep(.ant-modal) {
    width: 418px !important;
    .ant-modal-content {
      padding: 60px 89px;

      .modal-login {
        .title {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
          letter-spacing: 2px;
          text-align: center;
        }

        .sendcode {
          position: absolute;
          right: 12px;
          color: #1b7fbd;
        }

        .sure-btn {
          height: 36px;
          background: #1b7fbd;
        }

        .tip {
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 14px;
        }
      }
    }
  }
}
.captcha-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
